import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { TranslateModule } from "@ngx-translate/core";
import { ProgressSpinnerModule } from "@openng/optimus-ui/progressspinner";
import { createTimeoutSignal } from "../../utils/timeout.utils";
import { TimeoutComponent } from "../timeout/timeout.component";
import { SimplebarAngularModule } from "simplebar-angular";

@Component({
  standalone: true,
  selector: "app-kpi",
  imports: [SvgIconComponent, TranslateModule, ProgressSpinnerModule, TimeoutComponent, SimplebarAngularModule],
  templateUrl: "./kpi.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./kpi.component.scss",
})
export class KpiComponent {
  public title = input<string>();
  public label = input<string>();
  public iconName = input<string>();
  public iconColor = input<string>("primary");
  public compact = input<boolean>(false);
  public source = input<any | null>();
  public loading = computed(() => this.source() === null);
  public timeOut = createTimeoutSignal(this.loading);
}
